import React from 'react';

const MenuIcon = ({stroke = 'var(--primary)', size = 15, ...props}) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="18" height="14" viewBox="0 0 18 14">
    <path d="M196,438h16m-16,4h16m-16,4h16m-16,4h16" transform="translate(-195 -437)" fill="none" stroke={stroke}
          strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
  </svg>
);

export default MenuIcon;
